import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Dashboard from "./pages/Dashboard";
import Integrations from "./pages/Integrations";
import Agents from "./pages/Agents";
import Voices from "./pages/Voices";
import BrandKits from "./pages/BrandKits";
import SessionWorkspace from "./pages/SessionWorkspace";
import AuthCallback from "./pages/AuthCallback";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-[#F3F3F9]">
      <div className="w-8 h-8 border-3 border-[#4D11F6] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}

function AuthRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/signin" element={<AuthRoute><SignIn /></AuthRoute>} />
          <Route path="/signup" element={<AuthRoute><SignUp /></AuthRoute>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="agents" element={<Agents />} />
            <Route path="voices" element={<Voices />} />
            <Route path="brand-kits" element={<BrandKits />} />
            <Route path="sessions/:sessionId" element={<SessionWorkspace />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
